import { API_URL } from "../utils/auth";

const PUBLIC_URL = `${API_URL}/delivery/public/`;

export async function fetchPublicDeliverySettings({ signal } = {}) {
  const response = await fetch(PUBLIC_URL, { headers: { Accept: "application/json" }, signal });
  if (!response.ok) throw new Error("Delivery information could not be loaded.");
  return response.json();
}


const CHECK_URL = `${API_URL}/delivery/check/`;

export async function checkPublicDeliveryAddress(address, { signal } = {}) {
  const response = await fetch(CHECK_URL, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(address),
    signal,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data?.error?.message ||
        data?.message ||
        data?.detail ||
        "Delivery availability could not be checked.",
    );
  }
  return data;
}
